var $364e0798cc413123$exports = {};
$364e0798cc413123$exports = {
    "collectionLabel": `Sugest\xf5es`
};


export {$364e0798cc413123$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
